<template>
  <div class="tools-background">
    <div class="tools-container">
      <CellTypeDropDown :label="selectedLabel || 'Select RBC Type'" />
      <ReportReviewTiny class="title column right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import CellTypeDropDown from "./CellTypeDropDown.vue";
import ReportReviewTiny from "../../components/ReportReviewTiny.vue";

defineProps<{
  selectedLabel?: string;
}>();
</script>

<style lang="scss" scoped>
@use "@/assets/scss/common/alignment" as *;

.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #212121;
  display: flex;
  align-items: center;
  margin: 0 8px;
}

.tools-background {
  position: sticky;
  display: flex;
  top: 70px;
  width: 100%;
  padding: 10px;
  background: rgb(238, 238, 238);
  z-index: 10;
  border-bottom: 1px solid #ddd;
}

.tools-container {
  width: 100%;
  display: flex;
  justify-content: space-between;  
  gap: 16px;
}

.right {
  margin-left: auto; /* pushes this column to the right */
}
</style>
